import React from "react";
import CrossIcon from "../../../images/cross.svg"
import {
  PutColumnPreference,
  PostColumnPreference,
} from "../../../api/column_pref";
import "./customize_column.scss";
import { useState} from "react";
import CutomColumn from "../../../images/customcolumn.svg";
import CustomModal from "../CustomModal/CustomModal";
import CrossButton from "../ButtonSpinner/CrossButton";
import GeneralButton from "../SaveButton/GeneralButton";
import { Col, Row } from "react-bootstrap";

export const GetColmn = async (setCheckedStateDict, page_url, checkedStateDict, rowsPerPage, setRowsPerPage) => {
  if (checkedStateDict) {
    const { data: postData, error } = await PostColumnPreference(checkedStateDict, page_url, rowsPerPage);
    if (error) {
      setCheckedStateDict(checkedStateDict);
      if (setRowsPerPage) setRowsPerPage(rowsPerPage || 10);
      return;
    }
    if (postData?.data?.options && Object.keys(postData.data.options).length > 0) {
      setCheckedStateDict(postData.data.options);
    }
    if (setRowsPerPage) {
      setRowsPerPage(postData?.data?.rows_per_page || rowsPerPage || 10);
    }
  }
};

/**
 * Load column preference from backend and then call setPreferenceLoaded(true).
 * Use in a useEffect on mount so pages can gate their data fetch on preferenceLoaded.
 */
export const loadColumnPreference = async (
  setCheckedStateDict,
  page_url,
  checkedStateDict,
  rowsPerPage,
  setRowsPerPage,
  setPreferenceLoaded
) => {
  try {
    await GetColmn(setCheckedStateDict, page_url, checkedStateDict, rowsPerPage, setRowsPerPage);
  } catch (error) {
    console.error("Error loading column preference:", error);
  } finally {
    if (setPreferenceLoaded) setPreferenceLoaded(true);
  }
};

export const CustomizeColumn = ({
  page_url,
  setCheckedStateDict,
  checkedStateDict,
  pageType = null,
  rowsPerPage,
  setRowsPerPage,
  columnOrder = null,
}) => {
  const [show, setShow] = useState(false);
  const [tempCheckedStateDict, setTempCheckedStateDict] = useState({});

  const handleShow = () => {
    setTempCheckedStateDict({ ...checkedStateDict });
    setShow(true);
    GetColmn(setCheckedStateDict, page_url, checkedStateDict, rowsPerPage, setRowsPerPage);
    document.addEventListener("keydown", handleKeyDown);
  };

  const handleClose = () => {
    setTempCheckedStateDict({}); 
    setShow(false);
    document.removeEventListener("keydown", handleKeyDown);
  };

  const handleSave = async () => {
    const { data, error } = await PutColumnPreference(tempCheckedStateDict, page_url, rowsPerPage);
    if (data) {
      setCheckedStateDict(data.data.options); 
    }
    setTempCheckedStateDict({}); 
    handleClose();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      handleClose();
    }
  };

  const handleOnChangeDict = (item) => {
    const updatedCheckedState = { ...tempCheckedStateDict };
    updatedCheckedState[item] = !updatedCheckedState[item];
    setTempCheckedStateDict(updatedCheckedState);
  };

  const options = Object.keys(tempCheckedStateDict)
    .filter(item => {
      if (!pageType) return true; 
      

      if (pageType.includes("allocation")) {
        if (item === "User ID" && !pageType.includes("allocation_user")) return false;
        if (item === "Group ID" && !pageType.includes("allocation_group")) return false;
        if (item === "Role ID" && !pageType.includes("allocation_role")) return false;
      }
      
      return true;
    })
    .sort((a, b) => {
      if (!columnOrder) return 0;
      const indexA = columnOrder.indexOf(a);
      const indexB = columnOrder.indexOf(b);
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    })
    .map((item) => (
    <div
      key={item}
      className="mb-2 rounded custom-pointer border p-2"
      onClick={() => handleOnChangeDict(item)}
    >
      <input
        type="checkbox"
        className="mx-3 custom-pointer checkbox_size"
        checked={tempCheckedStateDict[item]}
        onChange={() => handleOnChangeDict(item)}
      />
      <label className="custom-pointer">{item}</label>
    </div>
  ));

  return (
    <>
      <CustomModal open={show} handleClose={handleClose} width="30% !important">
        <div>
          <div className="d-flex justify-content-between align-items-center  mb-4">
            <h3 className="border-0 customize-column-name mb-0 me-5">Customize Columns</h3>
            <CrossButton onClick={() =>{
              setShow(false)
            }}></CrossButton>
          </div>
          <div className="custom-modal-body pb-0">
            {options}
          </div>
          <Row className="pt-4 mb-3 justify-content-end">
            <Col sm="auto">
              <GeneralButton
                onClickEvent={handleClose}
                className="me-1"
                value="Cancel"
                color="#505050"
                variant="outlined"
                size="medium"
              />
            </Col>
            <Col sm="auto" className="me-sm-2 p-0">
              <GeneralButton
                onClickEvent={handleSave}
                className="me-1"
                value="Save"
                variant="contained"
                size="medium"
              />
            </Col>
          </Row>
        </div>
      </CustomModal>
      <div className="d-flex align-items-center qu">
        <button onClick={handleShow} className="advance_filter_button">
          <img src={CutomColumn} alt="icon" id="center-blueShadow" />
        </button>
      </div>
    </>
  );
};
        